import { InjectionToken } from '@angular/core';
import { CheckoutDirectDebitConfig } from '../models/checkout-direct-debit/checkout-direct-debit-config.type';

export const CHECKOUT_DIRECT_DEBIT_CONFIG =
  new InjectionToken<CheckoutDirectDebitConfig>('Checkout direct debit config');
